import '../../App.css';
import React, { useContext, useEffect, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarArea from '../../components/modal/ModalCadastrarArea';
import ModalEditarArea from '../../components/modal/ModalEditarArea';
import ModalExcluirArea from '../../components/modal/ModalExcluirArea';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function Area() {
    const { Success, Error, openModal, setOpenModal, AreasConsulta, ListaAreaConsulta, loading, modalEditarArea, setModalEditarArea, setEdicaoArea, setAreaAtualKey, modalExcluirArea, setModalExcluirArea, Permissao, ListaFiltroArea, totalRegistrosArea, filtroArea, totalRegistrosFiltroArea } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditArea = (props) => {
        setModalEditarArea(true)
        setAreaAtualKey(props.key)
        setEdicaoArea(props)
    }

    const DeletarArea = (props) => {
        setAreaAtualKey(props.key)
        setModalExcluirArea(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroArea(searchTerm, currentPage, pageSize);
        } else {
            ListaAreaConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroArea : totalRegistrosArea;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar área'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarArea &&
                <ModalEditarArea currentPage={currentPage} />
            }
            {modalExcluirArea &&
                <ModalExcluirArea currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {loading &&
                <LoadingScreen />
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarArea closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar área</button>
                    }
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Áreas cadastradas</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroArea : AreasConsulta}
                        columns={[
                            { label: "Área", field: "descricao", width: "40%" },
                            { label: "Área superior", field: "areaPai.descricao", width: "40%", render: (x) => x.areaPai?.descricao || "-" },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditArea(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarArea(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroArea(term, 1, 10);
                            } else {
                                ListaAreaConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Area;